(() => {
  if (customElements.get('matte-quick-gallery')) return;
  class MatteQuickGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-quick-images');
      if (!this.track) return;
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.count = this.querySelector('[data-gallery-count]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.tabIndex = 0;
      this.track.setAttribute('aria-label', 'Product photo gallery');
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.schedule());
      this.resize.observe(this.track);
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.track, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      this.schedule();
    }
    slides() { return [...this.track.children].filter(el => el.matches('.product-quick-images__slide') && el.getClientRects().length && getComputedStyle(el).display !== 'none'); }
    position(slides) {
      let nearest = 0, distance = Infinity;
      const left = this.track.getBoundingClientRect().left;
      slides.forEach((el, index) => {
        const d = Math.abs(el.getBoundingClientRect().left - left);
        if (d < distance) { nearest = index; distance = d; }
      });
      return nearest;
    }
    move(delta) {
      const slides = this.slides();
      const index = Math.max(0, Math.min(slides.length - 1, this.position(slides) + delta));
      const slide = slides[index];
      if (!slide) return;
      this.track.scrollBy({ left: slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const slides = this.slides();
        const index = this.position(slides);
        this.prev.hidden = this.next.hidden = slides.length < 2;
        this.prev.disabled = index === 0;
        this.next.disabled = index >= slides.length - 1;
        const label = slides.length > 1 ? `${index + 1} / ${slides.length}` : '';
        if (this.count.textContent !== label) this.count.textContent = label;
        slides.forEach((slide, i) => { if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause()); });
      });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('matte-quick-gallery', MatteQuickGallery);
})();
